import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { getFilter } from '../../../../../../../stores/algos-list/getters';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,

    '& li': {
      display: 'flex',
      margin: 0,
      padding: 0,
      marginBottom: 2,
      fontSize: '16px',
    },
  },
}));

const formattedNames = [
  {
    value: 'enabled',
    label: 'Enable',
  },
  {
    value: 'status',
    label: 'Status',
  },
  {
    value: 'broker',
    label: 'Client ID / Broker',
  },
  {
    value: 'multiplier',
    label: 'Multiplier',
  },
  {
    value: 'alerts',
    label: 'Alerts',
  },
  {
    value: 'algoStatus',
    label: 'Algo status',
  },
  {
    value: 'entryErrorCount',
    label: 'Entry error',
  },
  {
    value: 'exitErrorCount',
    label: 'Exit error',
  },
  {
    value: 'startTime',
    label: 'Start time',
  },
  {
    value: 'endTime',
    label: 'End time',
  },
  {
    value: 'tradingType',
    label: 'Trading type',
  },
  {
    value: 'underlyingSymbols',
    label: 'Underlying',
  },
  {
    value: 'transactionType',
    label: 'Buy/Sell',
  },
];

function useAppliedFilters() {
  const views = useSelector((state) => {
    const { views = {} } = getFilter(state);
    return views;
  });

  return Object.keys(views ?? {});
}

function useAppliedFilterNames() {
  const appliedFilters = useAppliedFilters();

  return appliedFilters.map((filter) => {
    const formattedName = formattedNames.find(({ value }) => value === filter);

    return formattedName?.label ?? filter;
  });
}

const FiltersList = () => {
  const classes = useStyles();
  const list = useAppliedFilterNames();

  return (
    <ul className={classes.root}>
      {list.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
};

export default FiltersList;
